

{
  "familyId": "TIJD-GEMIDDELDE",
  "questions": [
    {
      "id": "TIJD-GEMIDDELDE-001",
      "familyId": "TIJD-GEMIDDELDE",
      "module": "Tijd",
      "tier": 15,
      "levelCode": "E8",
      "group": 8,
      "skill": "snelheid",
      "subSkill": "snelheid_gemiddelde",
      "questionType": "multiple_choice",
      "question": "Een fietser rijdt 30 km in 2 uur. Wat is zijn gemiddelde snelheid?",
      "options": ["15 km/u", "30 km/u", "60 km/u", "32 km/u"],
      "correctAnswer": 0,
      "supportAids": [{ "type": "rule", "showWhen": "wrong", "data": { "title": "Gemiddelde snelheid", "content": "Gemiddelde snelheid = totale afstand ÷ totale tijd. 30 ÷ 2 = 15 km/u.", "icon": "lightbulb" } }],
      "conceptId": "gem_snelheid_basis",
      "variantIndex": 1,
      "citoDifficulty": 0.38,
      "citoDiscrimination": 0.75,
      "feedback": {
        "explanationText": "Gemiddelde snelheid bereken je met: snelheid = afstand ÷ tijd. 30 ÷ 2 = 15 km/u. Controleer: 15 × 2 = 30 km ✓.",
        "solutionSteps": ["Schrijf de gegevens op: afstand = 30 km, tijd = 2 uur", "Gebruik de formule: snelheid = afstand ÷ tijd", "Reken uit: 30 ÷ 2 = 15 km/u", "Controleer: 15 × 2 = 30 km ✓"],
        "distractorExplanations": {
          "0": "Goed! 30 ÷ 2 = 15 km/u.",
          "1": "Je dacht waarschijnlijk dat de snelheid gelijk is aan de afstand. Maar snelheid = afstand ÷ tijd: 30 ÷ 2 = 15 km/u.",
          "2": "Je hebt 30 × 2 = 60 berekend. Bij snelheid deel je altijd door de tijd, niet vermenigvuldigen.",
          "3": "Je hebt 30 + 2 = 32 berekend. Maar km en uren kun je niet optellen."
        }
      },
      "pedagogy": {
        "dok": 2,
        "misconceptionTags": [
          { "id": "tijd.snelheid-als-afstand", "label": "Verwart snelheid met afstand", "optionIndex": 1 },
          { "id": "tijd.snelheid-vermenigvuldigen", "label": "Vermenigvuldigt i.p.v. delen", "optionIndex": 2 },
          { "id": "tijd.eenheden-optellen", "label": "Telt km en uren bij elkaar op", "optionIndex": 3 }
        ]
      },
      "stimulusAids": [
        {
          "type": "speedDiagram",
          "showWhen": "always",
          "data": {
            "distance": 30,
            "time": 2,
            "distanceUnit": "km",
            "timeUnit": "uur",
            "speedUnit": "km/u",
            "unknown": "speed",
            "label": "Fietser: 30 km in 2 uur — gemiddelde snelheid?"
          }
        }
      ]
    },
    {
      "id": "TIJD-GEMIDDELDE-002",
      "familyId": "TIJD-GEMIDDELDE",
      "module": "Tijd",
      "tier": 15,
      "levelCode": "E8",
      "group": 8,
      "skill": "snelheid",
      "subSkill": "snelheid_gemiddelde",
      "questionType": "multiple_choice",
      "question": "Een auto rijdt 180 km in 2,5 uur. Wat is de gemiddelde snelheid?",
      "options": ["72 km/u", "90 km/u", "450 km/u", "182,5 km/u"],
      "correctAnswer": 0,
      "supportAids": [{ "type": "rule", "showWhen": "wrong", "data": { "title": "Delen door kommagetal", "content": "180 ÷ 2,5 = ? Tip: × 2 boven en onder → 360 ÷ 5 = 72 km/u.", "icon": "lightbulb" } }],
      "conceptId": "gem_snelheid_komma",
      "variantIndex": 2,
      "citoDifficulty": 0.48,
      "citoDiscrimination": 0.70,
      "feedback": {
        "explanationText": "Snelheid = afstand ÷ tijd = 180 ÷ 2,5. Truc: × 2 boven en onder → 360 ÷ 5 = 72 km/u. Controleer: 72 × 2,5 = 180 ✓.",
        "solutionSteps": ["Afstand = 180 km, tijd = 2,5 uur", "Formule: snelheid = afstand ÷ tijd", "180 ÷ 2,5 = 72 km/u (× 2 → 360 ÷ 5)", "Controleer: 72 × 2,5 = 180 km ✓"],
        "distractorExplanations": {
          "0": "Goed! 180 ÷ 2,5 = 72 km/u.",
          "1": "Je hebt 180 ÷ 2 = 90 berekend en het halve uur vergeten. Tijd is 2,5 uur, niet 2 uur.",
          "2": "Je hebt 180 × 2,5 = 450 berekend. Bij snelheid deel je altijd.",
          "3": "Je hebt 180 + 2,5 = 182,5 berekend. Km en uren kun je niet optellen."
        }
      },
      "pedagogy": {
        "dok": 2,
        "misconceptionTags": [
          { "id": "tijd.komma-tijd-negeren", "label": "Negeert kommadeel van tijd (2,5 → 2)", "optionIndex": 1 },
          { "id": "tijd.snelheid-vermenigvuldigen", "label": "Vermenigvuldigt i.p.v. delen", "optionIndex": 2 },
          { "id": "tijd.eenheden-optellen", "label": "Telt km en uren bij elkaar op", "optionIndex": 3 }
        ]
      },
      "stimulusAids": [
        {
          "type": "speedDiagram",
          "showWhen": "always",
          "data": {
            "distance": 180,
            "time": 2.5,
            "distanceUnit": "km",
            "timeUnit": "uur",
            "speedUnit": "km/u",
            "unknown": "speed",
            "label": "Auto: 180 km in 2,5 uur — gemiddelde snelheid?"
          }
        }
      ]
    },
    {
      "id": "TIJD-GEMIDDELDE-003",
      "familyId": "TIJD-GEMIDDELDE",
      "module": "Tijd",
      "tier": 15,
      "levelCode": "E8",
      "group": 8,
      "skill": "snelheid",
      "subSkill": "snelheid_gemiddelde",
      "questionType": "multiple_choice",
      "question": "Een hardloper rent 10 km in 50 minuten. Wat is zijn gemiddelde snelheid in km/u?",
      "options": ["12 km/u", "10 km/u", "5 km/u", "50 km/u"],
      "correctAnswer": 0,
      "supportAids": [{ "type": "rule", "showWhen": "wrong", "data": { "title": "Minuten naar uren", "content": "50 min = 5/6 uur. Snelheid = 10 ÷ (5/6) = 10 × 6/5 = 12 km/u. Of: 10 km in 50 min → in 60 min × 60/50 = 12 km.", "icon": "lightbulb" } }],
      "conceptId": "gem_snelheid_minuten",
      "variantIndex": 3,
      "citoDifficulty": 0.52,
      "citoDiscrimination": 0.68,
      "feedback": {
        "explanationText": "Reken minuten om: 50 min = 5/6 uur. Snelheid = 10 ÷ (5/6) = 10 × 6/5 = 12 km/u. Of: 10 km in 50 min → in 60 min (1 uur) = 10 × 60/50 = 12 km.",
        "solutionSteps": ["Afstand = 10 km, tijd = 50 min", "Reken om: 50 ÷ 60 = 5/6 uur", "Snelheid = 10 ÷ (5/6) = 10 × 6/5 = 12 km/u", "Controleer: 12 × 5/6 = 10 km ✓"],
        "distractorExplanations": {
          "0": "Goed! 10 ÷ (50/60) = 12 km/u.",
          "1": "Snelheid = afstand alleen werkt niet — de hardloper deed er minder dan 1 uur over, dus is hij sneller dan 10 km/u.",
          "2": "Je hebt 10 ÷ 2 = 5 berekend. Maar 50 minuten is geen 2 uur — het is 5/6 uur.",
          "3": "Je hebt de minuten als snelheid gelezen. 50 is de tijd, niet de snelheid."
        }
      },
      "pedagogy": {
        "dok": 2,
        "misconceptionTags": [
          { "id": "tijd.snelheid-als-afstand", "label": "Verwart snelheid met afstand", "optionIndex": 1 },
          { "id": "tijd.minuten-niet-omrekenen", "label": "Rekent minuten niet om naar uren", "optionIndex": 2 },
          { "id": "tijd.snelheid-als-tijd", "label": "Verwart snelheid met tijd in minuten", "optionIndex": 3 }
        ]
      },
      "stimulusAids": [
        {
          "type": "speedDiagram",
          "showWhen": "always",
          "data": {
            "distance": 10,
            "time": 50,
            "distanceUnit": "km",
            "timeUnit": "min",
            "speedUnit": "km/u",
            "unknown": "speed",
            "label": "Hardloper: 10 km in 50 min — gemiddelde snelheid in km/u?"
          }
        }
      ]
    },
    {
      "id": "TIJD-GEMIDDELDE-004",
      "familyId": "TIJD-GEMIDDELDE",
      "module": "Tijd",
      "tier": 15,
      "levelCode": "E8",
      "group": 8,
      "skill": "snelheid",
      "subSkill": "snelheid_gemiddelde",
      "questionType": "multiple_choice",
      "question": "Een auto rijdt 60 km met 40 km/u en daarna 60 km met 60 km/u. Wat is de gemiddelde snelheid over de hele rit?",
      "options": ["48 km/u", "50 km/u", "100 km/u", "45 km/u"],
      "correctAnswer": 0,
      "supportAids": [{ "type": "rule", "showWhen": "wrong", "data": { "title": "Strikvraag!", "content": "Gemiddelde snelheid ≠ gemiddelde van snelheden. Gebruik: totale afstand ÷ totale tijd. 60/40 = 1,5 u en 60/60 = 1 u. Totaal: 120 km in 2,5 u = 48 km/u.", "icon": "lightbulb" } }],
      "conceptId": "gem_snelheid_twee_delen",
      "variantIndex": 4,
      "citoDifficulty": 0.58,
      "citoDiscrimination": 0.66,
      "feedback": {
        "explanationText": "Strikvraag! (40+60)/2 = 50 is FOUT — dat klopt alleen als beide stukken even lang DUREN. Hier: deel 1 duurt 60÷40 = 1,5 u, deel 2 duurt 60÷60 = 1 u. Totaal: 120 km in 2,5 u = 48 km/u. Het langzamere stuk telt zwaarder.",
        "solutionSteps": ["Totale afstand: 60 + 60 = 120 km", "Tijd deel 1: 60 ÷ 40 = 1,5 uur", "Tijd deel 2: 60 ÷ 60 = 1 uur", "Totale tijd: 2,5 uur", "Gemiddelde: 120 ÷ 2,5 = 48 km/u"],
        "distractorExplanations": {
          "0": "Goed! 120 km ÷ 2,5 uur = 48 km/u.",
          "1": "Klassieke valkuil: (40+60)/2 = 50. Werkt alleen als beide stukken even lang duren. Het langzamere stuk (40 km/u) duurt 1,5 u, het snellere stuk maar 1 u — dus telt 40 km/u zwaarder.",
          "2": "Je hebt 40 + 60 = 100 gedaan. Snelheden tel je niet op.",
          "3": "Bijna, maar 120 ÷ 2,5 = 48, niet 45."
        }
      },
      "pedagogy": {
        "dok": 3,
        "misconceptionTags": [
          { "id": "tijd.snelheid-gemiddeld-naïef", "label": "Neemt rekenkundig gemiddelde van snelheden", "optionIndex": 1 },
          { "id": "tijd.snelheid-optellen", "label": "Telt snelheden bij elkaar op", "optionIndex": 2 },
          { "id": "tijd.snelheid-gemiddeld-rekenfout", "label": "Goede aanpak maar rekenfout", "optionIndex": 3 }
        ]
      },
      "stimulusAids": [
        {
          "type": "speedDiagram",
          "showWhen": "always",
          "data": {
            "distance": 120,
            "distanceUnit": "km",
            "speedUnit": "km/u",
            "timeUnit": "uur",
            "unknown": "speed",
            "label": "Hele rit: 120 km totaal (deel 1: 60 km @ 40 km/u, deel 2: 60 km @ 60 km/u) — gemiddelde snelheid?"
          }
        }
      ]
    },
    {
      "id": "TIJD-GEMIDDELDE-005",
      "familyId": "TIJD-GEMIDDELDE",
      "module": "Tijd",
      "tier": 15,
      "levelCode": "E8",
      "group": 8,
      "skill": "snelheid",
      "subSkill": "snelheid_gemiddelde",
      "questionType": "fill_in",
      "question": "Een schaatser legt 5 km af in 10 minuten. Wat is zijn gemiddelde snelheid in km/u?",
      "options": [],
      "correctAnswer": 0,
      "data": { "acceptedAnswers": ["30", "30 km/u"], "caseSensitive": false, "placeholder": "? km/u" },
      "supportAids": [{ "type": "rule", "showWhen": "wrong", "data": { "title": "Minuten naar uren", "content": "10 min = 1/6 uur. 5 ÷ (1/6) = 5 × 6 = 30 km/u. Of: 5 km in 10 min → in 60 min × 6 = 30 km.", "icon": "lightbulb" } }],
      "conceptId": "gem_snelheid_fill",
      "variantIndex": 5,
      "citoDifficulty": 0.45,
      "citoDiscrimination": 0.71,
      "feedback": {
        "explanationText": "10 min = 10/60 = 1/6 uur. Snelheid = 5 ÷ (1/6) = 5 × 6 = 30 km/u. Of: in 10 min = 5 km, dus in 60 min (6× zoveel tijd) = 30 km.",
        "solutionSteps": ["Afstand = 5 km, tijd = 10 min", "Reken om: 10/60 = 1/6 uur", "Snelheid = 5 ÷ (1/6) = 30 km/u", "Controleer: 30 × 1/6 = 5 km ✓"]
      },
      "pedagogy": {
        "dok": 2
      },
      "stimulusAids": [
        {
          "type": "speedDiagram",
          "showWhen": "always",
          "data": {
            "distance": 5,
            "time": 10,
            "distanceUnit": "km",
            "timeUnit": "min",
            "speedUnit": "km/u",
            "unknown": "speed",
            "label": "Schaatser: 5 km in 10 min — gemiddelde snelheid in km/u?"
          }
        }
      ]
    },
    {
      "id": "TIJD-GEMIDDELDE-006",
      "familyId": "TIJD-GEMIDDELDE",
      "module": "Tijd",
      "tier": 15,
      "levelCode": "E8",
      "group": 8,
      "skill": "snelheid",
      "subSkill": "snelheid_gemiddelde",
      "questionType": "true_false_series",
      "question": "Beoordeel elke uitspraak over gemiddelde snelheid.",
      "options": [],
      "correctAnswer": 0,
      "data": {
        "statements": [
          { "text": "Gemiddelde snelheid = totale afstand ÷ totale tijd.", "isTrue": true, "explanation": "Dit is de basisformule." },
          { "text": "Als je twee stukken met verschillende snelheid rijdt, is het gemiddelde altijd het rekenkundig gemiddelde van die snelheden.", "isTrue": false, "explanation": "Alleen als beide stukken even lang DUREN (niet even ver). Anders telt het langzamere stuk zwaarder." },
          { "text": "Snelheid in km/u betekent: hoeveel kilometer je in één uur aflegt.", "isTrue": true, "explanation": "Letterlijke betekenis van de eenheid km/uur." },
          { "text": "Bij een ritje van 15 km in een half uur is de snelheid 30 km/u.", "isTrue": true, "explanation": "15 ÷ 0,5 = 30 km/u." },
          { "text": "Als je in 20 minuten 4 km loopt, loop je 4 km/u.", "isTrue": false, "explanation": "20 min = 1/3 uur. 4 ÷ (1/3) = 12 km/u, niet 4 km/u." }
        ]
      },
      "stimulusAids": [],
      "supportAids": [
        { "type": "rule", "showWhen": "wrong", "data": { "title": "Twee valkuilen", "content": "1) Gemiddelde van snelheden klopt alleen bij gelijke TIJDEN, niet bij gelijke afstanden. 2) Bij minuten altijd eerst omrekenen naar uren.", "icon": "lightbulb" } }
      ],
      "conceptId": "gem_snelheid_tf",
      "variantIndex": 6,
      "citoDifficulty": 0.50,
      "citoDiscrimination": 0.72,
      "feedback": {
        "explanationText": "Twee veelgemaakte fouten: (1) denken dat het rekenkundig gemiddelde van snelheden altijd klopt — alleen bij gelijke tijden. (2) Minuten direct als uren behandelen — altijd eerst omrekenen.",
        "solutionSteps": [
          "Per stelling: check de formule en eenheden",
          "Reken bij minuten altijd eerst om naar uren",
          "Gemiddelde van snelheden = alleen bij gelijke tijden"
        ]
      },
      "pedagogy": {
        "dok": 3
      }
    },
    {
      "id": "TIJD-GEMIDDELDE-007",
      "familyId": "TIJD-GEMIDDELDE",
      "module": "Tijd",
      "tier": 15,
      "levelCode": "E8",
      "group": 8,
      "skill": "snelheid",
      "subSkill": "snelheid_gemiddelde",
      "questionType": "matching",
      "question": "Koppel elke situatie aan de gemiddelde snelheid.",
      "context": null,
      "options": [],
      "correctAnswer": 0,
      "data": {
        "leftItems": [
          { "id": "L1", "text": "20 km in 1 uur" },
          { "id": "L2", "text": "60 km in 1,5 uur" },
          { "id": "L3", "text": "10 km in 30 minuten" },
          { "id": "L4", "text": "8 km in 20 minuten" },
          { "id": "L5", "text": "100 km in 2 uur" }
        ],
        "rightItems": [
          { "id": "R1", "text": "20 km/u" },
          { "id": "R2", "text": "40 km/u" },
          { "id": "R3", "text": "20 km/u (ook)" },
          { "id": "R4", "text": "24 km/u" },
          { "id": "R5", "text": "50 km/u" }
        ],
        "correctPairs": [
          { "left": "L1", "right": "R1" },
          { "left": "L2", "right": "R2" },
          { "left": "L3", "right": "R3" },
          { "left": "L4", "right": "R4" },
          { "left": "L5", "right": "R5" }
        ]
      },
      "stimulusAids": [],
      "supportAids": [
        { "type": "rule", "showWhen": "wrong", "data": { "title": "Reken per situatie", "content": "Reken minuten om naar uren. Deel afstand door tijd. Let op dubbele waarden: 20 km in 1 u = 20 km/u, en 10 km in 0,5 u = ook 20 km/u.", "icon": "lightbulb" } }
      ],
      "conceptId": "gem_snelheid_matching",
      "variantIndex": 7,
      "citoDifficulty": 0.48,
      "citoDiscrimination": 0.71,
      "feedback": {
        "explanationText": "20÷1=20; 60÷1,5=40; 10÷0,5=20; 8÷(1/3)=24; 100÷2=50. Twee situaties leveren dezelfde gemiddelde snelheid (20 km/u) — dat is geen toeval: verschillende afstanden en tijden kunnen dezelfde snelheid opleveren.",
        "solutionSteps": [
          "Voor elke regel: zet tijd om naar uren",
          "Deel afstand door tijd",
          "Koppel aan de overeenkomende snelheid"
        ]
      },
      "pedagogy": {
        "dok": 2
      }
    },
    {
      "id": "TIJD-GEMIDDELDE-008",
      "familyId": "TIJD-GEMIDDELDE",
      "module": "Tijd",
      "tier": 15,
      "levelCode": "E8",
      "group": 8,
      "skill": "snelheid",
      "subSkill": "snelheid_gemiddelde",
      "questionType": "fill_in",
      "question": "Een treinrit van 240 km duurt 3 uur. Maar de trein staat 30 minuten stil bij een tussenstation. Wat is de gemiddelde snelheid over de hele reis (inclusief stilstand)? Typ je antwoord in km/u.",
      "context": "Bij gemiddelde reissnelheid telt stilstaan gewoon mee als tijd.",
      "options": [],
      "correctAnswer": 0,
      "data": { "acceptedAnswers": ["80", "80 km/u"], "caseSensitive": false, "placeholder": "? km/u" },
      "stimulusAids": [],
      "supportAids": [
        { "type": "rule", "showWhen": "wrong", "data": { "title": "Stilstand telt mee", "content": "Gemiddelde snelheid = totale afstand ÷ totale tijd. De totale tijd is 3 uur (incl. stilstand). 240 ÷ 3 = 80 km/u. De stilstand zit al in de 3 uur.", "icon": "lightbulb" } }
      ],
      "conceptId": "gem_snelheid_stilstand",
      "variantIndex": 8,
      "citoDifficulty": 0.55,
      "citoDiscrimination": 0.74,
      "feedback": {
        "explanationText": "De reis duurt totaal 3 uur — de stilstand zit hier al in. Gemiddelde snelheid = 240 ÷ 3 = 80 km/u. Tijdens het rijden zelf is de trein sneller, maar het gemiddelde over de hele reis is 80 km/u. Belangrijk: stilstaan telt mee als tijd.",
        "solutionSteps": [
          "Totale afstand = 240 km",
          "Totale tijd = 3 uur (inclusief 30 min stilstand)",
          "Gemiddelde = 240 ÷ 3 = 80 km/u"
        ]
      },
      "pedagogy": {
        "dok": 3,
        "misconceptionTags": [
          { "id": "tijd.snelheid-stilstand-aftrekken", "label": "Trekt stilstand af van rijtijd" }
        ]
      }
    },
    {
      "id": "TIJD-GEMIDDELDE-009",
      "familyId": "TIJD-GEMIDDELDE",
      "module": "Tijd",
      "tier": 15,
      "levelCode": "E8",
      "group": 8,
      "skill": "snelheid",
      "subSkill": "snelheid_gemiddelde",
      "questionType": "ordering",
      "question": "Zet deze ritjes op volgorde van traagste naar snelste gemiddelde snelheid.",
      "context": null,
      "options": [],
      "correctAnswer": 0,
      "data": {
        "items": [
          "5 km in 1 uur (= 5 km/u)",
          "15 km in 1,5 uur (= 10 km/u)",
          "20 km in 1 uur (= 20 km/u)",
          "12 km in 30 minuten (= 24 km/u)",
          "90 km in 2 uur (= 45 km/u)"
        ],
        "correctOrder": [0, 1, 2, 3, 4]
      },
      "stimulusAids": [],
      "supportAids": [
        { "type": "rule", "showWhen": "wrong", "data": { "title": "Bereken eerst, sorteer dan", "content": "Reken eerst voor elke rit de snelheid uit (afstand ÷ tijd, minuten omgerekend). Dan sorteer je de snelheden van klein naar groot.", "icon": "lightbulb" } }
      ],
      "conceptId": "gem_snelheid_ordering",
      "variantIndex": 9,
      "citoDifficulty": 0.50,
      "citoDiscrimination": 0.70,
      "feedback": {
        "explanationText": "Bereken eerst elke snelheid: 5÷1=5; 15÷1,5=10; 20÷1=20; 12÷0,5=24; 90÷2=45. Sorteer van klein naar groot: 5 < 10 < 20 < 24 < 45 km/u.",
        "solutionSteps": [
          "Reken voor elke rit de snelheid uit",
          "Reken minuten eerst om naar uren",
          "Sorteer de snelheden van klein naar groot"
        ]
      },
      "pedagogy": {
        "dok": 3
      }
    },
    {
      "id": "TIJD-GEMIDDELDE-010",
      "familyId": "TIJD-GEMIDDELDE",
      "module": "Tijd",
      "tier": 15,
      "levelCode": "E8",
      "group": 8,
      "skill": "snelheid",
      "subSkill": "snelheid_gemiddelde",
      "questionType": "fill_in",
      "question": "Een wielrenner rijdt het eerste uur 30 km en het tweede uur 50 km. Wat is zijn gemiddelde snelheid in km/u? Typ je antwoord.",
      "context": "Twee delen, allebei precies 1 uur.",
      "options": [],
      "correctAnswer": 0,
      "data": { "acceptedAnswers": ["40", "40 km/u"], "caseSensitive": false, "placeholder": "? km/u" },
      "stimulusAids": [],
      "supportAids": [
        { "type": "rule", "showWhen": "wrong", "data": { "title": "Gelijke tijden!", "content": "Hier duren beide stukken precies 1 uur. Bij gelijke tijden mag je het rekenkundig gemiddelde nemen: (30+50)/2 = 40 km/u. Of: totale afstand 80 km / totale tijd 2 u = 40 km/u.", "icon": "lightbulb" } }
      ],
      "conceptId": "gem_snelheid_gelijke_tijden",
      "variantIndex": 10,
      "citoDifficulty": 0.42,
      "citoDiscrimination": 0.69,
      "feedback": {
        "explanationText": "Twee uur, twee stukken — beide precies 1 uur. Totale afstand: 30 + 50 = 80 km. Totale tijd: 2 uur. Gemiddelde: 80 ÷ 2 = 40 km/u. Bij gelijke tijden mag je hier het rekenkundig gemiddelde (30+50)/2 = 40 nemen — het komt op hetzelfde neer.",
        "solutionSteps": [
          "Totale afstand: 30 + 50 = 80 km",
          "Totale tijd: 1 + 1 = 2 uur",
          "Gemiddelde: 80 ÷ 2 = 40 km/u"
        ]
      },
      "pedagogy": {
        "dok": 2
      }
    }
  ]
}

